import React, { useState } from 'react'
import { Grid , Label, Icon, Table} from 'semantic-ui-react'
import { AddBtn } from '../commonComponents/AddBtn'
// import InputField from '@commonComponents/formComponents/CustomInputField'

export const ContainerForm = React.memo((props) => {
  const { 
    containers, 
    deleteContainer, 
    addContainer,
    containerList, 
    translate, 
    isMerchandiseDisabled 
  } = props
  const [showContainerList, setShowContainerList] = useState(false)


  return (
    <div className='formContainer' style={{flexDirection:'column',position:'relative'}}>
      <Grid.Row>
        <Grid.Column
          style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', background: 'white' }}
        >
          {containers.map((container) => (
            <Label
              basic
              circular
              size='tiny'
              style={{ margin: '.3rem', background: '#F5F5F5' }}
              key={container.containerId}
            >
              {container?.containerNumber}
              <Icon
                onClick={() => {
                  deleteContainer(container?.containerAssociationId, 'containersList')
                  console.log('deleteContainer',container)
                }}
                name='delete'
                circular
                basic
                style={{ background: 'grey', color: '#fff' }}
                key={container?.id}
              />
            </Label>
          ))}
          <AddBtn
            onClick={(e) => {
              // e.stopPropagation()
              setShowContainerList(!showContainerList)
            }}
            text='ADD'
            size='tiny'
            style={{ margin: '.5rem' }}
            isDisabled={isMerchandiseDisabled}
          />
        </Grid.Column>
      </Grid.Row>
      {showContainerList && containerList?.length > 0 && (
        <Table selectable celled padded style={{position:'absolute',zIndex:'99',top:'2.2rem', width:'15rem'}} textAlign='center'>
          <Table.Body>
            {containerList.map((container) => (
              container.containerNumber && <Table.Row>
                <Table.HeaderCell
                  sorted='ascending'
                  width ='4'
                  selectable
                  key={container.id}
                  onClick={() => {
                    addContainer('containersList', {
                      containerNumber: container.containerNumber,
                      id: container.id
                    })
                    setShowContainerList(false)
                  }}
                >
                  {' '}
                  {container.containerNumber}
                </Table.HeaderCell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      )}
    </div>
  )
})

ContainerForm.defaultProps = {
  translate: (value) => value,
}
